export const canShowTypingHint = (containerId: string, query: string) =>
  !containerId && query.length > 0 && query.length < 10;
